import AbstractRequestTask from "../AbstractRequestTask";
import Device from "../../../devices/device";
import getAppConfig from "../../../config/appConfig";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class BadgesTask extends AbstractRequestTask {
  constructor(region = "") {
    super();

    this.region = region;
  }

  isValid (data){
    return (typeof data == 'object')
  }

  getUrl() {
    return getAppConfig().end_point_middleware + 'badges';
  }

  getParams() {
    const params = super.getParams();

    const appKey = Device.getDevice().getConfig().appKey;
    const region = this.region || params.region;
    const sessionKey = `${appKey}-${region}`;

    const newParams = {
      sessionKey,
      region
    };

    return Object.assign({}, params, newParams);
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default BadgesTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/application/BadgesTask.js